import React from "react";

import { Card, GridLegacy } from "@mui/material";

import CardBody from "../../../../components/Card/CardBody";
import FormTextTC from "../../../../components/Forms/FormTextTC";
import FormAsyncTC from "../../../../components/Forms/FormAsyncTC";
import { useFormContext } from "react-hook-form";

function Clubplanner() {
  const { menukaartVestigingId } = useFormContext();

  return (
    <div style={{ height: "100%", width: "100%", overflow: "hidden" }}>
      <Card>
        <CardBody alignItems={"flex-start"} style={{ padding: 16, display: "flex", flexWrap: "wrap" }}>
          <GridLegacy container spacing={1} style={{ maxWidth: 1400 }}>
            <FormTextTC name={"apiaccounts__clubplannerEndpoint"} tKey={"Url"} />
            <FormTextTC name={"apiaccounts__clubplannerToken"} tKey={"Token"} />
            <FormTextTC name={"apiaccounts__clubplannerPaymentId"} tKey={"Payment id"} />
            <FormTextTC name={"apiaccounts__clubplannerMemberId"} tKey={"Member id"} />
            <FormTextTC name={"apiaccounts__clubplannerOwnerId"} tKey={"Owner id"} />
            <FormAsyncTC
              async={{
                url:
                  "core/producten/search?fields=id as value, naam as label&per_page=50&sort_field=naam&vestiging_id=" +
                  menukaartVestigingId,
                searchField: "naam",
              }}
              key={"apiaccounts__serviceProduct_id" + menukaartVestigingId}
              name={"apiaccounts__serviceProduct_id"}
              nullable={true}
              tDefault={"Bediening (service)"}
              tKey={"vestigingen.form.apiaccounts.label.serviceProduct_id"}
            />
            <FormAsyncTC
              async={{
                url:
                  "core/producten/search?fields=id as value, naam as label&per_page=50&sort_field=naam&vestiging_id=" +
                  menukaartVestigingId,
                searchField: "naam",
              }}
              key={"apiaccounts__billProduct_id" + menukaartVestigingId}
              name={"apiaccounts__billProduct_id"}
              nullable={true}
              tDefault={"Rekening (service)"}
              tKey={"vestigingen.form.apiaccounts.label.billProduct_id"}
            />
          </GridLegacy>
        </CardBody>
      </Card>
    </div>
  );
}

export default Clubplanner;
